export default __webpack_public_path__ + "faa51fb2f7858589cec624a645a3c040.png";